import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorWeb3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.634 5.583C6.293 7.075 5.7 9.173 5.616 10.589a.75.75 0 0 1-.366.6c-.28.167-.691.512-1.021.925-.35.438-.489.801-.478 1.016 0 .007.003.152.475.317.428.149.984.21 1.426.225a.75.75 0 0 1 .725.75v3.34h3.9a.75.75 0 0 1 .73.926l-.605 2.489a.75.75 0 0 1-1.457-.354l.379-1.562H5.627a.75.75 0 0 1-.75-.75v-3.395a5.609 5.609 0 0 1-1.145-.253c-.587-.204-1.431-.669-1.48-1.66-.038-.777.391-1.508.805-2.025.329-.412.724-.783 1.093-1.055.171-1.636.862-3.867 2.369-5.543.822-.915 1.894-1.67 3.253-2.055 1.359-.385 2.956-.387 4.81.128 2.87.797 4.432 2.492 5.078 4.5a.75.75 0 1 1-1.428.458c-.481-1.495-1.636-2.842-4.052-3.513-1.634-.454-2.948-.428-3.999-.13-1.05.298-1.886.88-2.547 1.615Z"
    />
    <path
      fill="#F7A600"
      d="M10.25 8a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .624.334l1.777 2.666h2.6a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.625-.334L15.6 8.75H11a.75.75 0 0 1-.75-.75Zm1 8c0 .414.336.75.75.75h4a.75.75 0 0 0 .53-.22l1.78-1.78H21a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.53.22l-1.78 1.78H12a.75.75 0 0 0-.75.75ZM15 12.75a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5h4Z"
    />
  </svg>
);
export default SvgTwoColorWeb3;
